import React, { Component } from 'react';
import Seo from '$components/Seo';
import ReviewWrapper from '../ReviewWrapper';

class Essay extends Component {
  render() {
    const { history, match } = this.props;
    const { params } = match;
    const { essayResponseUuid } = params;

    return (
      <>
        <Seo title="Essay" canonical={null} description={null} />
        <ReviewWrapper
          history={history}
          match={match}
          mode="essay"
          essayResponseUuid={essayResponseUuid}
        />
      </>
    );
  }
}

export default Essay;
